import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { MessengerService } from '@services/messenger/messenger.service';

@Injectable()
export class PrivilegeGuard  {

  public static checkPrivileges(personalPrivileges, routePrivileges): boolean {
    return !!routePrivileges?.find(r => !!personalPrivileges?.find(p => { return p.privilegeName === r.name && p.value === r.value }));
  }

  constructor(private ms: MessengerService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!next.data.privileges) {
      return false;
    }

    if (this.ms.$activePrivileges.getValue()) {
      const isAllowed = PrivilegeGuard.checkPrivileges(this.ms.$activePrivileges.getValue(), next.data.privileges);
      return !isAllowed ? this.ms.displayErr('routing', null) : isAllowed;
    }

    return new Promise((resolve, reject) => {
      let privilegeSubscription;

      privilegeSubscription = this.ms.$activePrivileges.subscribe(personalActivePrivileges => {
        if (!personalActivePrivileges) {
          return;
        }
        privilegeSubscription.unsubscribe();
        resolve(PrivilegeGuard.checkPrivileges(personalActivePrivileges, next.data.privileges));
        if (!PrivilegeGuard.checkPrivileges(personalActivePrivileges, next.data.privileges)) {
          this.router.navigate([{ outlets: { 'primary': 'page-not-authenticated', org: this.ms.getOrganisation().name, auth: null } }]);
        }
      });
    });
  }

  public checkIfPrivilege(name: string, value: string): boolean {
    return !!this.ms.$activePrivileges.getValue()?.find(privilege => privilege.privilegeName === name && privilege.value === value);
  }
}
